export const mapNavigationPageSettings = ({ content }): Content.Navigation => ({
	documentType: content?.contentType,
	content: {
		properties: {
			navigationTitle: content.properties.navigationTitle,
			hideInNavigation: content.properties.umbracoNaviHide,
		},
	},
});
